import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export var AboutUs = function () {
    return (_jsx(_Fragment, { children: _jsx("span", { children: "AboutUs" }) }));
};
